import { generateWorkloadNameWithEnv } from "yam-operator/util"
import { K8SResourceType, KVString, OperateFunction } from "yam-types"
import { Settings } from "../settings.d"
import { Configuration } from "../types.d"
import { patchVolumeAndEnv } from "./util"

const configOperator: OperateFunction<Configuration> = async (plan, diff, settings: Settings) => {
  const workload = plan.data.workloadName
  for (const item of diff.currentItems) {
    // configMap should be isolated by application, use workload name as prefix
    let cfgName = workload + "-" + item.name
    if (item.refer) {
      const refName = item.refer.configMap
      if (!refName) {
        plan.log.warn(`no referred configMap specified for '${item.name}'`)
        continue
      }
      if (item.refer.isNative) {
        cfgName = refName
      } else {
        cfgName = (
          plan.data.multiEnvMode
            ? generateWorkloadNameWithEnv(item.refer.app as string, plan.data.envName)
            : item.refer.app
        ) + '-' + refName
      }
    }
    if (item.from) {
      const configMapData = {} as KVString
      for (const confPath of item.from) {
        const configData = await (item.disableRender ? plan.loadFile(confPath) : plan.renderTemplate(confPath, false))
        // avoid mount errors while using multiple level config,
        // eg: my-conf/~{ some.param }/app.config.yaml => mount as 'app.config.yaml'
        let tailingFilePath = confPath.substring(confPath.lastIndexOf('/') + 1)
        tailingFilePath = tailingFilePath.substring(confPath.lastIndexOf('\\') + 1)
        if (confPath.length !== tailingFilePath.length) {
          plan.log.info(`config file path '${confPath}' will be flatted to: '${tailingFilePath}'.`)
        }
        configMapData[tailingFilePath] = configData || ''
        plan.log.debug(`config '${item.name}' rendered from '${confPath}', value is:\n${configData}`)
      }

      plan.action(async (ctx) => {
        try {
          // save configMap at apply stage
          await ctx.k8sClient.saveConf({
            name: cfgName,
            data: configMapData,
            metadata: {
              annotations: settings.configMapAnnotations
            }
          })
        } catch (e) {
          ctx.log.error(`sync-configMap '${cfgName}' failed: ${e.message}`)
          throw e
        }
      }, `sync-configMap:${item.name}`)
    }

    plan.action(async (ctx) => {
      // patch deployment/statefulset yaml object
      patchVolumeAndEnv(ctx, item, plan, cfgName, "configMap")
    }, `mount-configMap:${item.name}`)
  }

  // remove deleted configMap if deletedItems found
  for (const deletedItem of diff.deletedItems) {
    plan.action(async (ctx) => {
      await ctx.k8sClient.delete({
        name: deletedItem.name,
        namespace: plan.data.namespace,
        kind: K8SResourceType.ConfigMap
      })
      ctx.log.info(`configMap ${deletedItem.name} has been deleted from cluster`)
    }, `delete-configMap:${deletedItem.name}`)
  }

}


export default configOperator